import { render, staticRenderFns } from "./EmptyListImageProjects.vue?vue&type=template&id=710de3ca&scoped=true"
var script = {}
import style0 from "./EmptyListImageProjects.vue?vue&type=style&index=0&id=710de3ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710de3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710de3ca')) {
      api.createRecord('710de3ca', component.options)
    } else {
      api.reload('710de3ca', component.options)
    }
    module.hot.accept("./EmptyListImageProjects.vue?vue&type=template&id=710de3ca&scoped=true", function () {
      api.rerender('710de3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageProjects.vue"
export default component.exports